export const getAuthHeaders = (contentType: string | null = 'application/json') => {
  const token = localStorage.getItem('authToken');
  return {
    ...(contentType !== null && { 'Content-Type': contentType }),
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
};